/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import axios from 'axios';
import Cookies from 'js-cookie';
import { getStorage, removeStorage } from '../utils/auth-utils';

const postRequest = async (url: string, data: object, headers: object = { 'Content-Type': 'application/json' }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        headers: {
          Authorization: getStorage('token'),
          ...headers,
        },
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          removeStorage('token');
          Cookies.remove('access_token');
          Cookies.remove('refresh_token');
          window.location.reload();
        }
        resolve(error.response.data);
      });
  });
};

const getRequest = async (url: string) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: getStorage('token'),
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          removeStorage('token');
          Cookies.remove('access_token');
          Cookies.remove('refresh_token');
          window.location.reload();
        } else resolve(error.response.data);
      });
  });
};

const putRequest = async (url: string, data: object) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, data, {
        headers: {
          Authorization: getStorage('token'),
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          removeStorage('token');
          Cookies.remove('access_token');
          Cookies.remove('refresh_token');
          window.location.reload();
        }
        resolve(error.response.data);
      });
  });
};

const patchRequest = async (url: string, data: object) => {
  return new Promise((resolve, _reject) => {
    axios
      .patch(url, data, {
        headers: {
          Authorization: getStorage('token'),
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          removeStorage('token');
          Cookies.remove('access_token');
          Cookies.remove('refresh_token');
          window.location.reload();
        }
        resolve(error.response.data);
      });
  });
};

const deleteRequest = async (url: string) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        headers: {
          Authorization: getStorage('token'),
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          removeStorage('token');
          Cookies.remove('access_token');
          Cookies.remove('refresh_token');
          window.location.reload();
        }
        resolve(error.response.data);
      });
  });
};

export { postRequest, getRequest, putRequest, patchRequest, deleteRequest };
